import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {inAnteprima} from '../../skin';
import {indirizzoImmagine} from '../../utils/immagini';
import Nota from './Nota';

/**
 * QUATTRO PROMO (blocco «promo» della Home): fino a quattro riquadri sotto
 * il banner, uno accanto all'altro dal computer, due per riga sul tablet, in
 * fila da scorrere sul telefono. Ogni riquadro: un'immagine (o il colore
 * della skin), un titolo, una riga, un pulsante, e un indirizzo dove porta.
 *
 * DAL BACKOFFICE PARTE TUTTO (Moduli › Home › Quattro promo): qui non c'e'
 * nessun bonus scritto. Senza voci il posto vuoto lo vede solo chi compone
 * la skin; a chi gioca il blocco non c'e'. Piu' di quattro voci: le altre
 * si tagliano, perche' la riga e' fatta per quattro.
 */
export const QUANTE_PROMO = 4;

export default function Promo({titolo, voci}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const intestazione = String(titolo || '').trim();
  const buone = (Array.isArray(voci) ? voci : [])
      .filter((v) => v && (String(v.titolo || '').trim() || String(v.immagine || '').trim()))
      .slice(0, QUANTE_PROMO);
  if (!buone.length) {
    if (!inAnteprima()) return null;
    return (
      <section className={'vet-blocco vet-promo'} aria-label={intestazione || t('Promo')}>
        {intestazione && <div className={'vet-testata'}><h2>{intestazione}</h2></div>}
        <div className={'vet-promo-riga'} aria-hidden={'true'}>
          {[0, 1, 2, 3].map((i) => <div key={i} className={'vet-promo-carta vuota'}/>)}
        </div>
        <Nota tono={'spento'} etichetta={t('da scrivere')}>
          {t('I quattro riquadri si scrivono dal backoffice (Moduli › Home › Quattro promo). Oggi non ce n’è nessuno: si vede il posto, non una promo inventata.')}
        </Nota>
      </section>
    );
  }
  const vai = (dove) => {
    if (!dove) return;
    if (/^https?:\/\//i.test(dove)) window.open(dove, '_blank', 'noopener');
    else navigate(dove);
  };
  return (
    <section className={'vet-blocco vet-promo'} aria-label={intestazione || t('Promo')}>
      {intestazione && <div className={'vet-testata'}><h2>{intestazione}</h2></div>}
      <div className={'vet-promo-riga'}>
        {buone.map((v, i) => {
          const immagine = String(v.immagine || '').trim();
          const nome = String(v.titolo || '').trim();
          const riga = String(v.testo || '').trim();
          const pulsante = String(v.pulsante || '').trim();
          const dove = String(v.collegamento || '').trim();
          const Scatola = dove ? 'button' : 'div';
          return (
            <Scatola key={i} className={'vet-promo-carta' + (immagine ? ' con-immagine' : '')}
              type={dove ? 'button' : undefined} onClick={dove ? () => vai(dove) : undefined}
              aria-label={dove ? nome || t('Apri {{dove}}', {dove}) : undefined}>
              {immagine && <img className={'vet-promo-immagine'} src={indirizzoImmagine(immagine)} alt={''}/>}
              <span className={'vet-promo-testi'}>
                {nome && <b>{nome}</b>}
                {riga && <small>{riga}</small>}
                {pulsante && <span className={'vet-promo-tasto'}>{pulsante}</span>}
              </span>
            </Scatola>
          );
        })}
      </div>
    </section>
  );
}
